var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TemporaryRailwayMenuSettingLineFormModel } from '.';
var TemporaryRailwayMenuSettingCompanyFormModel = /** @class */ (function () {
    function TemporaryRailwayMenuSettingCompanyFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, _b = _a.railwayLines, railwayLines = _b === void 0 ? [] : _b, _c = _a.name, name = _c === void 0 ? '' : _c;
        this.id = id;
        this.railwayLines = railwayLines.map(function (railwayLine) {
            return TemporaryRailwayMenuSettingLineFormModel.assign(railwayLine);
        });
        this.name = name;
    }
    TemporaryRailwayMenuSettingCompanyFormModel.assign = function (data) {
        return new TemporaryRailwayMenuSettingCompanyFormModel(data);
    };
    TemporaryRailwayMenuSettingCompanyFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, line, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _i = 0, _a = this.railwayLines;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        line = _a[_i];
                        _b = this;
                        return [4 /*yield*/, line.init(this.id)];
                    case 2:
                        _b.name = _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TemporaryRailwayMenuSettingCompanyFormModel.makeRailwayCompany = function (selectedItemList) {
        var uniqueLineIds = Array.from(new Set(selectedItemList.map(function (item) { return item.lineId; })));
        var railwayLines = uniqueLineIds.map(function (lineId) {
            var filteredSelectedItemList = selectedItemList.filter(function (item) { return item.lineId === lineId; });
            return TemporaryRailwayMenuSettingLineFormModel.makeRailwayLine(filteredSelectedItemList);
        });
        return TemporaryRailwayMenuSettingCompanyFormModel.assign({
            id: selectedItemList[0].companyId,
            railwayLines: railwayLines,
            name: selectedItemList[0].companyName,
        });
    };
    TemporaryRailwayMenuSettingCompanyFormModel.prototype.updateLines = function (selectedItemList) {
        var _this = this;
        var uniqueLineIds = Array.from(new Set(selectedItemList.map(function (item) { return item.lineId; })));
        // 削除
        this.railwayLines = this.railwayLines.filter(function (line) { return uniqueLineIds.indexOf(line.id) !== -1; });
        this.railwayLines = uniqueLineIds.map(function (lineId) {
            // 予めlineIdで絞る
            var filteredSelectedItemList = selectedItemList.filter(function (item) { return item.lineId === lineId; });
            var targetLine = _this.railwayLines.find(function (line) { return line.id === lineId; });
            if (targetLine) {
                targetLine.updateStations(filteredSelectedItemList);
                return targetLine;
            }
            else {
                return TemporaryRailwayMenuSettingLineFormModel.makeRailwayLine(filteredSelectedItemList);
            }
        });
    };
    TemporaryRailwayMenuSettingCompanyFormModel.prototype.setRadius = function (lineId, radius) {
        var line = this.railwayLines.find(function (line) { return line.id === lineId; });
        if (line) {
            line.radius = radius;
        }
    };
    TemporaryRailwayMenuSettingCompanyFormModel.prototype.setRadiusToAllRadiusTarget = function (radius) {
        this.railwayLines.forEach(function (line) { return (line.radius = radius); });
    };
    return TemporaryRailwayMenuSettingCompanyFormModel;
}());
export { TemporaryRailwayMenuSettingCompanyFormModel };
